<template>
  <ImageWrapper
    imagePath="assets/images/Teaser_Password"
    imageName="Teaser_Password"
    :breakpoints="[300, 300, 353, 353, 353]"
  ></ImageWrapper>
</template>

<script setup lang="ts">
import ImageWrapper from '@/components/rahmen/ImageWrapper.vue'
</script>
